/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React, { useEffect } from 'react';
  
import FullscreenSpinner from 'common/fullscreenSpinner.component';
import { setBackButtonPath, setPageTitle } from 'modules/layout/layout.actions';
import { getClientSettings, getPolicies } from '../estimator.actions';
import PolicyEditorPage from './policyEditorPage.component';
  
  const PolicyEditor = (props) => {  

    useEffect(() => {
        (async () => {
            props.setPageTitle('My Policies');
            props.setBackButtonPath('/estimatorPolicies');
            await props.getPolicies();
            await props.getClientSettings();
        })();
    }, []);

    return (
        <>
            {props.policies && <PolicyEditorPage history={props.history}/>}
            {!props.policies && <FullscreenSpinner/>}
        </>
    );
  }
  
  const mapStateToProps = (state) => {
    return {
        policies: state.estimator.get('policies'),
    };
  };
  
  export default withRouter(
    connect(mapStateToProps, {
      getPolicies,
      setPageTitle,
      setBackButtonPath,
      getClientSettings,
    })(PolicyEditor),
  );
  